import jsPDF from 'jspdf'
import 'jspdf-autotable'
import WebKoruri from 'raw-loader!./WebKoruri.base64'


function makeDoc() {
    var doc = new jsPDF('landscape', 'pt', 'a3')
    doc.addFileToVFS("WebKoruri.ttf", WebKoruri);
    doc.addFont('WebKoruri.ttf', 'WebKoruri', 'regular');
    doc.setFont('WebKoruri', 'regular');
    return doc
}

export { makeDoc }